const ROUTES = {
  "/": {
    "name": "HomePageDa61957a71ba45caAc9b42f666ed30f8",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPagesEa7acbe84a2d4059B278293eaa837ae5",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage8979418297d74e9c90a407ff3f8e5610",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPage467c8232De2c48f280060994f42f3c42",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/events/public": {
    "name": "PublicEventsPageA72cc2ed1a204fdbA2a021d40931618d",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPageA26e9b1322ac4469B64f252069808545",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members/*": {
    "name": "MemberPages318866092f2243fc8c7b0c05ebc0d508",
    "type": "HTML",
    "key": "member-pages"
  },
  "/members/messages/*": {
    "name": "MessagePagesF76e6fc5E86d4e6a97d9F29eb9729c45",
    "type": "HTML",
    "key": "message-pages"
  },
  "/resources": {
    "name": "ResourcesPageC040cadf4bac463e904e6456d750f401",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPages68f8eef435a549128d100258ae2dde19",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;